import React, { useState } from 'react';
import OlcButton from '~/components/General/OlcButton';

// MUI Components
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';

// Icons
import { ArchiveConfirmCIcon, CloseModalIcon } from '~/assets/images';

// Styles identical to Tags delete modal
import '~/components/Settings/Tags/DeleteTagModal/styles.scss';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ArchiveModal = (props) => {
  const { openModal, handleCloseModal, onConfirm, title = 'Archive Sub-Company' } = props;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm?.();
      handleCloseModal();
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  return (
    <BootstrapDialog onClose={handleCloseModal} open={openModal} className="genericConfirmModal">
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{ position: 'absolute', right: 20, top: 20, padding: '0', zIndex: 1000 }}
      >
        <img src={CloseModalIcon} alt="icon" />
      </IconButton>
      <DialogContent className="modalContent">
        <Box className="submitHeader">
          <img src={ArchiveConfirmCIcon} alt="icon" />
        </Box>
        <Box className="modalHeader">
          <Typography gutterBottom variant="h4">
            {title}
          </Typography>
        </Box>
        <Box className="modalMessage">
          <Typography>
            Are you sure you want to archive this Sub-Company? Archiving will keep it linked to all
            existing orders, and other work, but it will no longer be active for new activity.
          </Typography>
        </Box>
        <Box className="modalBtns">
          <OlcButton variant="primary" onClick={handleConfirm} disabled={loading}>
            {loading ? (
              <CircularProgress
                sx={{ color: 'white', width: '25px !important', height: '25px !important' }}
              />
            ) : (
              'Yes'
            )}
          </OlcButton>
          <OlcButton variant="secondary" onClick={handleCloseModal}>No</OlcButton>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ArchiveModal;
